// #665, gate 665 D15, Session 79.22b.4.4 -- THE GIVING SHELF, ON AN APPROVAL CARD.
//
// Drawn by the Requests inbox card and the Transfers page's Awaiting
// confirmation card, from approvalShelfLine() in src/lib/transferLoads.js, so
// the two approval screens say the same sentence in the same colours.
//
// Amber when the giving branch would drop below its reorder point: #8A5A10 on
// white, 5.9 (gate F4). A warning, never a block -- the card's Approve stays
// usable whatever this says.
import React from 'react';

export default function ShelfLine({ shelf }) {
  if (!shelf) return null;
  return (
    <>
      <div style={{ fontSize: 12, color: shelf.amber ? '#8A5A10' : '#5C5C5C', fontWeight: shelf.amber ? 700 : 400 }}>
        {shelf.text}
      </div>
      {shelf.warning && (
        <div style={{ fontSize: 12, color: '#8A5A10' }}>{shelf.warning}</div>
      )}
    </>
  );
}
